import { buildApiUrl, sendGetRequest, sendPutRequest, Type } from '@/api/api'
import { assertSchemaAndReturn } from '@/helpers/assert-schema'
import { EditManualAssetSchema,type UpdateManualAsset } from '@/api/assets/schemas'
import { AssetType } from '@/features/assets/constants'

export async function getManualAssetDetails(assetCode : string){
    const url = buildApiUrl(Type.Core, `asset/${assetCode}/manual`)
    const { data } = await sendGetRequest(url)

    return assertSchemaAndReturn(data, EditManualAssetSchema)
  }

  export async function updateManualAssetDetails(assetCode: string, manualAsset: UpdateManualAsset){
    const url = buildApiUrl(Type.AssetManagement, `asset/${assetCode}/manual`)
    await sendPutRequest(url, { data: manualAsset })
  }
